import React, { useContext, useEffect } from "react";
import { Button } from "@mantine/core";
import { Navigate, useSearchParams } from "react-router-dom";
import { HttpClientError } from "../../../providers/HttpClient";
import { queryClient } from "../../../App";
import useCloseMultipleAnnouncementApiService from "../services/api/CloseMultipleAnnouncementApiService";
import Announcement from "../services/model/Announcement";
import { AuthContext } from "../../../providers/AuthProvider";
import { useToasts } from "../../../providers/notifications/ToastsContext";

type AnnouncementCloseMultipleButtonProps = {
  announcements: Announcement[];
};

const AnnouncementCloseMultipleButton: React.FC<
  AnnouncementCloseMultipleButtonProps
> = ({ announcements }) => {
  const auth = useContext(AuthContext);
  const { showToast } = useToasts();

  const [searchParams] = useSearchParams();
  const { isLoading, isError, error, isSuccess, data, mutate } =
    useCloseMultipleAnnouncementApiService();

  useEffect(() => {
    if (isError) {
      showToast({
        strapiId: "announcement_closing_failed",
        data: {
          message: HttpClientError(error),
        },
      });
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess && auth) {
      showToast({ strapiId: "announcement_closed_success", data });

      queryClient
        .invalidateQueries([
          "AnnouncementListApiService",
          searchParams.get("page"),
          auth.employer.id,
        ])
        .then();
    }
  }, [isSuccess, auth]);

  if (!auth) {
    return <Navigate replace to="/login" />;
  }

  return (
    <div>
      {isLoading || announcements.length === 0 ? (
        <div />
      ) : (
        <Button
          mr={4}
          variant="outline"
          onClick={() => mutate(announcements.map((it) => it.id))}
          loading={isLoading}
          color="jem-theme"
          loaderPosition="right"
        >
          Close Selected
        </Button>
      )}
    </div>
  );
};

export default AnnouncementCloseMultipleButton;
